import React from "react";
// import Loadergif from '../staticimage/loader.gif'
// import './Loader.scss'
import Loadergif from '../staticimage/secondzapptalk.gif'

const Loader = () => (
  // <div style={{ 
  //   display: 'flex', 
  //   justifyContent: 'center', 
  //   alignItems: 'center', 
  //   height: '100vh',
  //   flexDirection: 'column'
  // }}>
  //   <div style={{
  //     width: '40px',
  //     height: '40px',
  //     border: '4px solid #f3f3f3',
  //     borderTop: '4px solid #3498db',
  //     borderRadius: '50%',
  //     animation: 'spin 1s linear infinite',
  //     marginBottom: '1rem'
  //   }}></div>
  //   {/* <span style={{ color: '#666', fontSize: '16px' }}>Loading...</span> */}
  //   <img 
  //     src={Loadergif} 
  //     alt="Loading..." 
  //     style={{ width: '240px', height: '240px' }}
  //   />


  //   <style>
  //     {`
  //       @keyframes spin {
  //         0% { transform: rotate(0deg); }
  //         100% { transform: rotate(360deg); }
  //       }
  //     `}
  //   </style>
  // </div>
  // <div className="loader">Zapp Talk...</div>
  <>
  <div className="loader"><img src={Loadergif} alt="Loading..." style={{width: "300px", height:'300px'  }}/></div>
  </>
);

export default Loader; 